import React from "react";
import { Route, IndexRedirect, Redirect } from "react-router";
import App from "./components/app.jsx";
import Welcome from "./components/welcome.jsx";
import Marquee from "./components/marquee.jsx";
import Admin from "./components/admin.jsx";
import CookiePreferences from "./components/cookie-preferences.jsx";
import CompleteKioskOrder from "./components/complete-kiosk-order.jsx";
import Login from "./components/login.jsx";
import Forgot from "./components/forgot.jsx";
import Reset from "./components/reset.jsx";
import Activate from "./components/activate.jsx";
import Account from "./components/account.jsx";
import EditPaymentMethod from "./components/overlays/edit-payment-method.jsx";
import RequestAccountDeletion from "./components/request-account-deletion.jsx";
import Schedule from "./components/schedule.jsx";
import QuickOrderOverlay from "./components/overlays/quick-order.jsx";
import CartOverlay from "./components/overlays/cart.jsx";
import Event from "./components/event.jsx";
import BuyTicketsOverlay from "./components/overlays/buy-tickets.jsx";
import Tickets from "./components/tickets.jsx";
import ScanTicketsOverlay from "./components/overlays/scan-tickets.jsx";
import AcceptTicketTransferOverlay from "./components/overlays/accept-ticket-transfer.jsx";
import Films from "./components/films.jsx";
import Film from "./components/film.jsx";
import Passes from "./components/passes.jsx";
import ScanPassOverlay from "./components/overlays/scan-pass.jsx";
import AcceptPassTransferOverlay from "./components/overlays/accept-pass-transfer.jsx";
import PassSubscriptions from "./components/pass-subscriptions.jsx";
import RenewSubscriptionOverlay from "./components/overlays/renew-subscription.jsx";
import PassSales from "./components/pass-sales.jsx";
import BuyPassesOverlay from "./components/overlays/buy-passes.jsx";
import DynamicTenantPage from "./components/dynamic-tenant-page.jsx";
import Donate from "./components/donate.jsx";
import DonateOverlay from "./components/overlays/donate.jsx";
import Credits from "./components/credits.jsx";
import BuyCreditsOverlay from "./components/overlays/buy-credits.jsx";
import GiftCards from "./components/gift-cards.jsx";
import GiftCardsOverlay from "./components/overlays/gift-cards.jsx";
import BallotingRecord from "./components/partials/balloting-record.jsx";
import CheckPass from "./components/check-pass.jsx";

const mainRoute =
  !TENANT.marquee_enabled && TENANT.include_welcome_page
    ? "/welcome"
    : TENANT.use_film_guide_as_main_page
    ? "/films"
    : "/schedule";

var AppRoutes = (
  <Route path="/" component={App}>
    {!TENANT.marquee_enabled && TENANT.include_welcome_page ? (
      <Route path="welcome" component={Welcome} />
    ) : null}

    {TENANT.additional_routes
      .filter(r => !!r.path)
      .map(route => {
        return (
          <Route
            key={route.path}
            path={route.path}
            component={DynamicTenantPage}
          />
        );
      })}
    {/* In the admin interface, we let users create new routes. Since we can't initialize new
        routes after the initial router initialization, we have this pseudo-route-thing that we can
        use to show live previews of the new routes. */}
    <Route
      path="admin_route_preview/:forcePath"
      component={DynamicTenantPage}
    />

    <Route path="cookie_preferences" component={CookiePreferences} />

    <Route path="admin" component={Admin} />

    <Route path="complete_kiosk" component={CompleteKioskOrder} />

    <Route path="login" component={Login} />
    <Route path="forgot" component={Forgot} />
    <Route path="reset" component={Reset} />
    <Route path="activate" component={Activate} />

    <Route path="account" component={Account}>
      <Route
        path="payment"
        component={EditPaymentMethod}
        onEnter={EditPaymentMethod.willTransitionTo}
        onLeave={EditPaymentMethod.willTransitionAway}
        ignoreScrollBehavior={true}
      />
    </Route>
    <Route
      path="account/request-delete"
      component={RequestAccountDeletion}
      ignoreScrollBehavior={true}
    />

    <Route
      path="schedule"
      component={TENANT.marquee_enabled ? Marquee : Schedule}
    >
      <Route
        path="tickets/:eventId"
        onEnter={BuyTicketsOverlay.willTransitionTo}
        onLeave={BuyTicketsOverlay.willTransitionAway}
        component={BuyTicketsOverlay}
        ignoreScrollBehavior={true}
      />
      <Route
        path="quick/schedule"
        onEnter={QuickOrderOverlay.willTransitionTo}
        onLeave={QuickOrderOverlay.willTransitionAway}
        component={QuickOrderOverlay}
        ignoreScrollBehavior={true}
      />
      <Route
        path="checkout"
        onEnter={CartOverlay.willTransitionTo}
        onLeave={CartOverlay.willTransitionAway}
        component={CartOverlay}
        ignoreScrollBehavior={true}
      />
    </Route>
    <Route
      path="schedule/(**-):eventId"
      component={Event}
      scrollPastBanner={true}
    >
      <Route
        path="tickets"
        onEnter={BuyTicketsOverlay.willTransitionTo}
        onLeave={BuyTicketsOverlay.willTransitionAway}
        component={BuyTicketsOverlay}
        ignoreScrollBehavior={true}
      />
      <Route
        path="quick/event"
        onEnter={QuickOrderOverlay.willTransitionTo}
        onLeave={QuickOrderOverlay.willTransitionAway}
        component={QuickOrderOverlay}
        ignoreScrollBehavior={true}
      />
    </Route>
    <Route path="tickets" component={Tickets} ignoreScrollBehavior={true}>
      <Route path="accept_transfer" component={AcceptTicketTransferOverlay} />
      <Route
        path=":eventId"
        onEnter={ScanTicketsOverlay.willTransitionTo}
        component={ScanTicketsOverlay}
        ignoreScrollBehavior={true}
      />
    </Route>

    <Route
      path="balloting"
      onEnter={BallotingRecord.willTransitionTo}
      component={BallotingRecord}
      ignoreScrollBehavior={true}
    />

    <Route path="check_pass" component={CheckPass} />

    <Route path="films" component={Films} />
    <Route path="films/(**-):filmId" component={Film} scrollPastBanner={true}>
      <Route
        path="tickets/:eventId"
        onEnter={BuyTicketsOverlay.willTransitionTo}
        onLeave={BuyTicketsOverlay.willTransitionAway}
        component={BuyTicketsOverlay}
        ignoreScrollBehavior={true}
      />
    </Route>

    {TENANT.passes_enabled
      ? [
          <Route
            path={`${TENANT.passes_url_pathname}/buy`}
            component={PassSales}
          >
            <Route
              path=":code"
              onEnter={BuyPassesOverlay.willTransitionTo}
              component={BuyPassesOverlay}
              ignoreScrollBehavior={true}
            />
          </Route>,

          <Route path={TENANT.passes_url_pathname} component={Passes}>
            <Route
              path="accept_transfer"
              component={AcceptPassTransferOverlay}
            />
            <Route
              path=":passId"
              onEnter={ScanPassOverlay.willTransitionTo}
              component={ScanPassOverlay}
              ignoreScrollBehavior={true}
            />
          </Route>,

          <Route path="subscriptions" component={PassSubscriptions}>
            <Route
              path="renew"
              onEnter={RenewSubscriptionOverlay.willTransitionTo}
              component={RenewSubscriptionOverlay}
              ignoreScrollBehavior={true}
            />
          </Route>,

          TENANT.passes_url_pathname !== "passes" // for admin configurator - allow passes alias
            ? [
                <Redirect path="passes" to={TENANT.passes_url_pathname} />,
                <Redirect
                  path="passes/buy"
                  to={`${TENANT.passes_url_pathname}/buy`}
                />
              ]
            : null,

          TENANT.passes_url_pathname !== TENANT.display_passes &&
          TENANT.display_passes !== "passes" // for old display_passes based urls
            ? [
                <Redirect
                  path={TENANT.display_passes}
                  to={TENANT.passes_url_pathname}
                />,
                <Redirect
                  path={`${TENANT.display_passes}/buy`}
                  to={`${TENANT.passes_url_pathname}/buy`}
                />
              ]
            : null
        ]
      : null}

    <Route path="donate" component={Donate}>
      <Route
        path="go"
        onEnter={DonateOverlay.willTransitionTo}
        component={DonateOverlay}
        ignoreScrollBehavior={true}
      />
    </Route>

    <Route path="giftcards" component={GiftCards}>
      <Route
          path="go"
          onEnter={GiftCardsOverlay.willTransitionTo}
          component={GiftCardsOverlay}
          ignoreScrollBehavior={true}
        />
    </Route>

    <Route path="credits" component={Credits}>
      <Route
        path="topup"
        onEnter={BuyCreditsOverlay.willTransitionTo}
        component={BuyCreditsOverlay}
        ignoreScrollBehavior={true}
      />
    </Route>

    <IndexRedirect to={mainRoute} />
    <Redirect path="*" to={mainRoute} />
  </Route>
);

export default AppRoutes;



// WEBPACK FOOTER //
// ./src/app/app-routes.jsx